/* RESPONSIBLE TEAM: team-workflows */
import type { RenderableData } from '../renderable-data';
import { RenderableType } from 'embercom/models/data/inbox/renderable-types';
import { EntityType } from 'embercom/models/data/entity-types';

interface WorkflowIntroWireFormat {
  renderable_type: RenderableType;
  blocks: Array<object>;
  workflow_id?: number;
}

export default class WorkflowIntro implements RenderableData {
  readonly renderableType = RenderableType.WorkflowIntro;
  readonly blocks: Array<object>;
  readonly workflowId?: number;

  get creatingEntity() {
    return { type: EntityType.Bot, id: -1 };
  }

  get styles() {
    return {
      backgroundColor: 'bg-neutral-container',
      textColor: 'text-default',
      backgroundColorHover: 'bg-neutral-container-emphasis',
    };
  }

  constructor(blocks: any[], workflowId?: number) {
    this.blocks = blocks;
    this.workflowId = workflowId;
  }

  static deserialize(json: WorkflowIntroWireFormat): WorkflowIntro {
    return new WorkflowIntro(json.blocks || [], json.workflow_id);
  }
}
